<template>
    <div class="field is-horizontal">
        <div class="field-label">
            <label class="label">Group:</label>
        </div>
        <div class="field-body">
            <div class="field">
                <div class="control">
                    <div class="select" :class="{'is-loading': isLoading}"  :disabled="isLoading">
                        <select @change="setGroup" :disabled="isLoading">
                            <option v-for="(group, key) in getGroups"
                                    :selected="isSelected(group)"
                                    :value="key"
                                    :disabled="isDisabled(group)">
                                {{ group.name }}  ({{ getBidsNumber(group) }})
                            </option>
                            <option value="new">{{ getNewGroup.name }} (new)</option>
                        </select>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        computed: {
            isLoading() {
                return this.$store.getters.getGroupLoadingStatus
            },
            getNewGroup() {
                return this.$store.getters.getNewGroup
            },
            getGroups() {
                return this.$store.getters.getGroups
            },
        },
        methods: {
            isSelected(group) {
                return this.$store.getters.getSelectedGroup.id === group.id
            },
            isDisabled(group) {
                return group.bid.length >= this.$store.getters.getGroupSettings.max_group_bids
            },
            setGroup(event) {
                if (event.target.value === 'new') {
                    this.$store.dispatch('changeSelectedGroup', this.$store.getters.getNewGroup)
                } else {
                    this.$store.dispatch('changeSelectedGroup', this.getGroups[event.target.value])
                }
            },
            getBidsNumber(group) {
                return group.bid.length + '/' + this.$store.getters.getGroupSettings.max_group_bids
            }

        }
    }

</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/Auctions/Advance/BiddingModal/Inputs/GroupSelect.vue